import type { ShadowDefinition } from "@/shadow/types";
import type { StatAllocation } from "@/game/model/character-stats";
import { STAT_IDS } from "@/game/model/character-stats";

export function shadowEquippedStatBonus(
  shadow: ShadowDefinition | null | undefined,
): Partial<StatAllocation> | undefined {
  if (!shadow) return undefined;
  const out: Partial<StatAllocation> = {};
  for (const id of STAT_IDS) {
    const n = shadow.statAllocation[id];
    if (n > 0) out[id] = n;
  }
  return Object.keys(out).length > 0 ? out : undefined;
}
